import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getStudentMasterCourses } from '../../../service/student/studentCourses.service';
import { BreadCrumRoutes, truncateString } from '../../../helpers/helpers';
import { FaCheck, FaRupeeSign, FaStar, FaStopwatch } from 'react-icons/fa';
import Loaders from '../../../components/loaders/Loaders';
import BreadCrumb from '../../../components/breadcrumb/BreadCrumb';
import { Helmet } from 'react-helmet-async';

export default function StuCourses() {
  const [courseMaster, setCouseMaster] = useState<any>([]);
  const [imageLoad, setImageLoad] = useState(true);
  const [pageLoad, setPageLoad] = useState(false);
  const [breadCrumRoutes, setBreadCrumRoutes] = useState<any>();
  const [courseCategory, setCourseCategory] = useState<any>([]);
    const [courseFilter, setCourseFilter] = useState<any>("null")
    const [courseCategoryFilter, setCourseCategoryFilter] = useState<any>("null")
  const [searchParams] = useSearchParams()
  const navigate = useNavigate();
  const location = useLocation();
  const fetchCourseMaster = async () => {
    setPageLoad(true);
    let get: any = await getStudentMasterCourses(
      searchParams.get('filter'),
      searchParams.get('category')
    );
    if (get?.status === 'success') {
      setCouseMaster(get?.message.data);
      setCourseCategory(get?.message.courseMaster);
      setPageLoad(false);
    }
    setPageLoad(false);
  };
    useEffect(()=>{
        if(searchParams.get('filter')){
          fetchCourseMaster();
          setCourseFilter(searchParams.get('filter'))
          // setCourseFilter(searchParams.get('filter'))
        }else{
          setCourseFilter("null")
          fetchCourseMaster();
        }
         if(searchParams.get('category')){
          fetchCourseMaster();
          setCourseCategoryFilter(searchParams.get('category'))
          // setCourseFilter(searchParams.get('filter'))
        }else{
          setCourseCategoryFilter("null")
          fetchCourseMaster();
        }
    },[searchParams])
  useEffect(() => {
    // fetchCourseMaster();
    setBreadCrumRoutes(
      BreadCrumRoutes(
        'Courses List',
        location.pathname,
        'studentcoursesList',
        true
      )
    );
  }, []);
  const handleScroll = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <div>
      <Helmet>
        <title>{`Courses List | ${window.location.hostname}`}</title>
      </Helmet>
      {pageLoad ? (
        <Loaders type="spinner" />
      ) : (
        <>
          <BreadCrumb routes={breadCrumRoutes} />
          {/* {
            courseFilter === "null" &&
            courseMaster.length > 0 &&
            <div className=" gap-3 mb-5 flex flex-wrap flex-row justify-between items-center p-3">
              {
                 courseMaster.map((e: any, index: number) =>(
                 e.course.length > 0 &&
                 index > 3 &&
                 <button onClick={() => handleScroll(`courseCategory${e.id}`)} className='bg-purple-800 text-white rounded-lg py-2 px-4' >{e.name}</button>
                ))
              }
            </div>
          } */}
         {
          courseCategory.length > 0 ?
            courseCategory.map((e: any, index: number) => (
              courseMaster.filter((item:any,i:number) => item.fk_courseMaster_id === e.id).length > 0 &&
              <div key={index}>
                  <div className='my-3 p-2 bg-purple-200  rounded-xl flex justify-between items-center'>
                  <p id={`courseCategory${e.id}`} className="text-2xl pl-3 font-bold">
                    {
                      e.name
                    }
                  </p>
                  {
                    courseFilter === "null"  &&
                    <button className='px-2 py-1 bg-purple-800 text-white rounded-lg' onClick={(()=>navigate('/student/courses?filter='+e.slug))}>View All</button>
                  }
                </div>
                <div className='grid grid-cols-12 gap-3'>
                {
                   courseMaster.filter((item:any,i:number) => item.fk_courseMaster_id === e.id).map((course: any, ind: number) => (
                   <div key={ind} className='col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-3'>
                    {
                  ind < 5 &&
                  <div
                    key={ind}
                    className=" "
                  >
                    <div
                      data-tooltip={course.name}
                      data-tooltip-location="bottom"
                      className=" rounded-2xl bg-gray-200 hover:border-gray-300 border-gray-200 border-2 hover:shadow-lg hover:border-2"
                    >
                      {course.popular && (
                        <p className=" absolute bg-purple-700 p-2 flex gap-1 items-center rounded-full left-1 top-1 text-white">
                          {' '}
                          <FaStar className="" />
                        </p>
                      )}
                      {course.studentSubscription.length !== 0 && (
                        <p className="absolute right-1 text-white p-2 top-2  rounded-lg bg-green-700">
                          {' '}
                          <FaCheck />{' '}
                        </p>
                      )}
                      <p className=" absolute bg-purple-500 py-1 px-2 flex gap-1 items-center rounded-md right-2 bottom-[7rem] text-white">
                        {' '}
                        {course.amount === '0' ? (
                          'FREE'
                        ) : (
                          <>
                            <FaRupeeSign />
                            {course.amount}
                          </>
                        )}{' '}
                      </p>
                      <img
                        src={course.image}
                        className=" rounded-2xl  w-full"
                        alt=""
                      />

                      <div
                        onClick={() =>
                          navigate(`/student/courses/detail/${course.slug}`)
                        }
                        className="px-2 py-2  flex justify-between items-center "
                      >
                        <p
                          onClick={() =>
                            navigate(`/student/courses/detail/${course.slug}`)
                          }
                          className="hover:cursor-pointer font-semibold text-xl mb-2"
                        >
                          {truncateString(course.name, 15)}
                        </p>
                        <p className="flex gap-1  items-center ">
                          <FaStopwatch />
                          {course.duration} Days
                        </p>
                      </div>

                      <div className="px-2 py-2    ">
                        <button
                          onClick={() =>
                            navigate(`/student/courses/detail/${course.slug}`)
                          }
                          className="w-full p-2 rounded-lg text-white bg-purple-800"
                        >
                          {' '}
                          Know More{' '}
                        </button>
                      </div>
                    </div>
                  </div>
                }
                   </div>
                   ))
                }
                </div>
              </div>
              
            ))
          :null
         }
         {
          courseMaster.length>0 ?
            courseMaster.map((item:any, index:number) => (
              <div key={index}>
                {item.fk_courseMaster_id === null &&
                  <div key={index}>
                    <div className='my-3 p-2 bg-purple-200  rounded-xl flex justify-between items-center'>
                  <p  className="text-2xl pl-3 font-bold">
                    {
                      "Courses"
                    }
                  </p>
                
                </div>
 <div className="grid grid-cols-12 gap-3">
             
               
                  <div
                    key={index}
                    className=" col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-3"
                  >
                    <div
                      data-tooltip={item.name}
                      data-tooltip-location="bottom"
                      className=" rounded-2xl bg-gray-200 hover:border-gray-300 border-gray-200 border-2 hover:shadow-lg hover:border-2"
                    >
                      {item.popular && (
                        <p className=" absolute bg-purple-700 p-2 flex gap-1 items-center rounded-full left-1 top-1 text-white">
                          {' '}
                          <FaStar className="" />
                        </p>
                      )}
                      {item.studentSubscription.length !== 0 && (
                        <p className="absolute right-1 text-white p-2 top-2  rounded-lg bg-green-700">
                          {' '}
                          <FaCheck />{' '}
                        </p>
                      )}
                      <p className=" absolute bg-purple-500 py-1 px-2 flex gap-1 items-center rounded-md right-2 bottom-[7rem] text-white">
                        {' '}
                        {item.amount === '0' ? (
                          'FREE'
                        ) : (
                          <>
                            <FaRupeeSign />
                            {item.amount}
                          </>
                        )}{' '}
                      </p>
                      <img
                        src={item.image}
                        className=" rounded-2xl  w-full"
                        alt=""
                      />

                      <div
                        onClick={() =>
                          navigate(`/student/courses/detail/${item.slug}`)
                        }
                        className="px-2 py-2  flex justify-between items-center "
                      >
                        <p
                          onClick={() =>
                            navigate(`/student/courses/detail/${item.slug}`)
                          }
                          className="hover:cursor-pointer font-semibold text-xl mb-2"
                        >
                          {truncateString(item.name, 15)}
                        </p>
                        <p className="flex gap-1  items-center ">
                          <FaStopwatch />
                          {item.duration} Days
                        </p>
                      </div>

                      <div className="px-2 py-2    ">
                        <button
                          onClick={() =>
                            navigate(`/student/courses/detail/${item.slug}`)
                          }
                          className="w-full p-2 rounded-lg text-white bg-purple-800"
                        >
                          {' '}
                          Know More{' '}
                        </button>
                      </div>
                    </div>
                  </div>
               
              </div>
                  </div>
                }
              </div>
            ))
          :null
         }

        </>
      )}
    </div>
  );
}
